module.exports = __webpack_public_path__ + "img/thumbnail-rainforest.b1b9effd.jpg";